import { Component, OnInit } from '@angular/core';
import { DailyProductionService } from './daily-production.service';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { TranslatePipe } from '@ngx-translate/core';
import { CulturalPipe } from '../../../../pipes/cultural.pipe';

@Component({
    selector: 'app-daily-production',
    imports: [TranslatePipe, CulturalPipe],
    templateUrl: './daily-production.html',
    styleUrl: './daily-production.scss'
})
export class DailyProduction {

    constructor(
        public themeService: CustomizerSettingsService,
        private dailyProductionService: DailyProductionService
    ) { }

    ngAfterViewInit(): void {
        this.dailyProductionService.loadChart();
    }

    ngOnDestroy(): void {
        this.dailyProductionService.destroyChart();
    }

}